/**
 * Step ids for the create-object-type wizard.
 *
 * These live in their own module because two files need them and neither may
 * import the other: the wizard renders the review pane, so the review pane
 * cannot import the wizard back without a cycle.
 *
 * Ids rather than indices: the step list is conditional — the Pipeline step
 * only exists for the one kind that rides a pipeline — so a step's position
 * changes with the customer's answers. Anything that points at a step (a
 * review section's "Edit" button, a jump target) has to name it.
 */
export const OBJECT_TYPE_WIZARD_STEPS = {
  basics: 'basics',
  kind: 'kind',
  fields: 'fields',
  associations: 'associations',
  pipeline: 'pipeline',
  review: 'review',
} as const;

export type ObjectTypeWizardStepId =
  (typeof OBJECT_TYPE_WIZARD_STEPS)[keyof typeof OBJECT_TYPE_WIZARD_STEPS];
